/**
 * Sources / Default / Components / Overwrites / Shared > Media Gallery
 *
 * @copyright 2026 i-fabrik GmbH
 * @author Tobias Garz
 */

import {extend} from '../../../../../shared/utils';
import {
	isElement,
	isString
} from '../../../../../shared/utils/is';

import SelectorEngine from '../../../../../shared/dom/selector-engine';
import Data           from '../../../../../shared/dom/data';
import Manipulator    from '../../../../../shared/dom/manipulator';

import MediaGallery from '../../../../../shared/components/media-gallery/media-gallery';

// -------
// Private
// -------

const NAME                  = 'media-gallery';
const DATA_KEY              = `ifab.${NAME}`;
const SLIDER_ITEM_TPL       = `<div class="swiper-slide slider-item"/>`;
const SLIDER_ITEM_INNER_TPL = `<div class="swiper-slide__inner"/>`;
const MG_ITEM_TPL           = `<div class="${NAME}-item"/>`;

const buildSliderItem = (figures) => {
	const sliderItem       = Manipulator.createElementFrom(SLIDER_ITEM_TPL);
	const sliderItemInner  = Manipulator.createElementFrom(SLIDER_ITEM_INNER_TPL);
	const mediaGalleryItem = Manipulator.createElementFrom(MG_ITEM_TPL);

	// Figures in den innersten Container verschieben
	for (const figure of figures) {
		mediaGalleryItem.append(figure);
	}

	// Von innen nach außen zusammenbauen
	sliderItemInner.append(mediaGalleryItem);
	sliderItem.append(sliderItemInner);

	return sliderItem;
};

const groupFiguresIntoSlides = (wrapper, itemsPerSlide = 3) => {
	const figures = [...SelectorEngine.find('.figure', wrapper)];

	if (!figures.length) return;

	const fragment = document.createDocumentFragment();

	for (let i = 0; i < figures.length; i += itemsPerSlide) {
		const chunk = figures.slice(i, i + itemsPerSlide);
		fragment.append(buildSliderItem(chunk));
	}

	wrapper.append(fragment);
};

const render = (element, o) => {
	const WRAPPER = SelectorEngine.findOne(`.swiper-wrapper`, element);

	if (!WRAPPER) return;

	groupFiguresIntoSlides(WRAPPER);
	MediaGallery.init(element, {
		slider: {
			slidesPerGroupAuto: true
		}
	});
};

// -------
// Public
// -------

const init = () => {
	const COLLECTION = SelectorEngine.find(`[data-c="${NAME}-mega-slider"]`);

	if (!COLLECTION.length) return;

	for (const element of COLLECTION) {
		render(element);
	}
};

// -------
// Export
// -------

export default { init: init };